

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import User from "@/types/user"
import { Case, CaseDetails } from "@/types"
import { UserStatus } from "@/types/userStatus"
import api from "@/services/api"
import apiUserStatus from "@/services/api_UserStatus"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class UserStatusSetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	@caseStore.Getter("getCases") public cases: any;
	@caseStore.Action public casesLoad!: () => void;
	@caseStore.Action public detailsLoad!: (refreshData: boolean) => void;

	@Action public refreshUserInfo!: () => void;

	private loading: boolean = false;
	private userStatuses: UserStatus[] = [];

	public async mounted () {
		await this.loadUserStatuses()
	}

	private get columns (): any[] {
		return [
			{ key: "title", label: "Title", sortable: true, errors: (item: any) => (item.title !== "") ? null : "Please enter a title" }
		]
	}

	private async loadUserStatuses () {
		this.loading = true
		this.userStatuses = await apiUserStatus.userStatusList()
		this.loading = false
	}

	private createUserStatus () {
		return { id: null, title: "" }
	}

	private async saveUserStatus (status: UserStatus) {
		const currentStatus = this.userStatuses.find(s => s.id === status.id)

		// Add / update
		if (status.id === null || (currentStatus && currentStatus.title !== status.title)) {
			status.id = await apiUserStatus.userStatusSave(status)
		}

		this.loadUserStatuses()

		// Store
		this.loading = true
		const refreshData: boolean = true
		await this.detailsLoad(refreshData)
		this.refreshUserInfo()

		this.loading = false
	}

	private async deleteUserStatus (status: UserStatus) {
		this.loading = true
		await apiUserStatus.userStatusDelete(status)
		this.loadUserStatuses()
		// Store
		this.loading = true
		const refreshData: boolean = true
		await this.detailsLoad(refreshData)
		this.refreshUserInfo()
		this.loading = false
	}
}
